module.exports = __webpack_public_path__ + "static/img/history_msg.2604b4b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/history_msg.png
// module id = 1879
// module chunks = 0